export const BASE_API = `${process.env.VUE_APP_BASE_API}`
export const AUTH_API = `${BASE_API}/auth`
export const PDF_PUBLIC_PATH = `${process.env.VUE_APP_PDF_PUBLIC_PATH}`
export const IMG_PUBLIC_PATH = `${process.env.VUE_APP_IMG_PUBLIC_PATH}`
export const FILES_PUBLIC_PATH = `${process.env.VUE_APP_API_FILES}`

// https://msc-backend-api.herokuapp.com/api'
